import React from 'react';
import { useDispatch } from 'react-redux';
import FormInput from 'components/FormInput';
import TextInputModal from 'components/TextInputModal';
import useConnectedModal from 'containers/ConnectedModal/useConnectedModal';

import { cancelPollForProjectNameGeneration } from 'redux/modules/project/actions';
import { Dispatch } from 'redux/types';
import RenameClipModalInputAdornment from './RenameClipModalInputAdornment';
import useRenameClip from './useRenameClip';

import { block } from './utils';

const RenameClipModal: React.FC = () => {
  const { show, onHide, onExited, params } = useConnectedModal('RenameClip');

  const {
    clipName,
    isRenamingClip,
    isGeneratingClipName,
    onChangeClipName,
    onRenameClip,
    onGenerateClipName,
  } = useRenameClip({
    projectId: params?.projectId,
    defaultClipName: params?.clipName,
  });

  const dispatch = useDispatch<Dispatch>();

  return (
    <TextInputModal
      {...{ show, onHide, onExited }}
      backdrop
      noCancelButton
      title="Rename clip"
      submitText="update title"
      className={block()}
      bodyClassName={block('body')}
      isLoading={isGeneratingClipName}
      loadingMessage="Generating a new title"
      defaultValue={clipName}
      renderInput={(_, onChange) => {
        return (
          <FormInput
            type="input"
            bsSize="large"
            controlSizes={{ xs: 12 }}
            value={clipName}
            disabled={isRenamingClip}
            className={block('input')}
            onChange={(e: any) => {
              const newValule = e.target.value;

              onChange(newValule);
              onChangeClipName(newValule);
            }}
            endAdornment={
              <RenameClipModalInputAdornment
                isDisabled={isRenamingClip}
                onGenerateClipName={onGenerateClipName}
              />
            }
          />
        );
      }}
      onSubmit={onRenameClip}
      onHide={() => {
        dispatch(cancelPollForProjectNameGeneration());
        onHide();
      }}
    />
  );
};

export default RenameClipModal;
